import * as selectors from './humanresources.selectors';
import reducer from './humanresources.reducers';

export default reducer;
export { selectors, reducer };
export { HumanResourceAction } from './humanresources.actions';
export { HumanResourceEffects } from './humanresources.effects';
export { HumanResourceState, HumanResource } from './humanresources.models';
export { HumanResourceService } from './humanresources.service';
